<template>
  <div class="AppTextFieldSuggestion bg-surface-info text-text-secondary">
    <div>
      <span>{{ $t('common.identity-checking.AppTextFieldSuggestion.didYouMean') }}</span>
      <span class="font-weight-medium ml-2 text-text-primary">{{ suggestedValue }}</span>
    </div>
    <div>
      <app-button
        type="ghost"
        variant="transparent"
        @click="$emit('validate')"
      >
        <app-material-icon
          name="check_circle"
          class="mr-1"
          size="xs"
        />
        {{ $t('common.validate') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'
export default {
  name: 'AppTextFieldSuggestion',
  components: { AppButton },
  props: {
    suggestedValue: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.AppTextFieldSuggestion {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  @include border-radius('border-radius-3');
  padding: 10px 8px;
  color: white;
  font-size: 12px;
  &:before {
    content: '';
    width: 8px;
    height: 8px;
    background-color: inherit;
    position: absolute;
    top: -4px;
    left: 10px;
    transform: rotate(45deg);
  }
}
</style>
